<style lang="less">
    @import "../../../../styles/common-table-list.less";
</style>
<template>
    <div class="center-table-list" style="position:relative;">
        <div class="img-title">
            <img src="@/assets/tip.png" alt='版权登记'/>
            <span>公证处将在1到3个工作日完成确认函审核,请耐心等待。</span>
        </div>

        <div class="table-list" style="height:auto;min-height: 726px">
            <div class="table-list-title">
                <span style="margin-left:25px">我的确认函</span>
                <div class="choose-group">
                    <span class="choose-group-span">时间</span>
                    <Date-picker @on-change="changeDate" :value="value2" format="yyyy-MM-dd" type="daterange"
                                 placement="bottom-end" placeholder="选择日期" style="width: 200px"></Date-picker>

                    <div class="father-box-input">
                        <input placeholder="请输入确认函名称" v-model="name" class="select-input-self"
                               @keyup.enter="addworkname"></input>
                        <img @click="addworkname" src="@/assets/search.png" class="search-icon" alt='版权登记'/>
                    </div>
                    <button style="margin-right: 30px;" @click="addworkname" class="btn-84">查询</button>
                </div>
            </div>

            <Row class="table-style-size">
                <i-col span="5">确认函名称</i-col>
                <i-col span="2">关联内容</i-col>
                <!--                <i-col span="3">纸质确认函审核状态</i-col>-->
                <i-col span="3">证书签发状态</i-col>
                <i-col span="4">存证/取证时间</i-col>
                <i-col span="3">提交确认函时间</i-col>
                <i-col span="4">确认函</i-col>
                <i-col span="2">操作</i-col>
            </Row>
            <div v-if="records.length>0">
                <Row class="table-style-size table-style-body" v-for="(item,index) in records" :key="index">
                    <i-col span="5">
                        <Tooltip :content="item.name" placement="top">
                            <span style="display:inline-block;width: 240px;" class="notwrap">{{item.name}}</span>
                        </Tooltip>
                    </i-col>
                    <i-col span="2">
                        <router-link class="jump_link" v-if="item.ordertype == 'oc_notarial' "
                                     :to="'/cert-info?id=' + item.orderCommon.id">存证
                        </router-link>
                        <router-link class="jump_link" v-else :to="'/evidence-info?id=' + item.evidenceWebpage.id">取证
                        </router-link>
                    </i-col>
                    <!--                    <i-col span="3"></i-col>-->
                    <i-col span="3">{{
                        item.status == 3 ? '证据文件上传中'
                        : item.status == 5 ? '归档中'
                        : item.status == 7 ? '确认函生成中'
                        : item.status == 9 ? '已完结'
                        : '创建成功'
                        }}
                    </i-col>
                    <i-col span="4">{{ item.ordertype == 'oc_notarial' ? item.orderCommon.createDate :
                        item.evidenceWebpage.createDate }}
                    </i-col>
                    <i-col span="3">{{ item.encCreateDate }}</i-col>
                    <i-col span="4">
                        <Tooltip v-if="item.downloadfileurl && item.downloadfileurl!=''" content="电子数据确认函证书" placement="top">
                            <a target="_blank"  :href="item.downloadfileurl">
                                <img class="notarization_icon" :src=" ifNotarizationSuccess" alt="电子数据确认函" />
                            </a>
                        </Tooltip>

                        <Tooltip v-else content="暂无电子数据确认函证书" placement="top">
                            <img :src="ifNotarizationFail" alt='版权登记'>
                        </Tooltip>
                    </i-col>
                    <i-col span="2">
                        <!--                        <button class="btn-84" style="margin-right:20px">电子数据确认函</button>-->
                        <router-link style="display: inline-block;" class="btn-84"
                                     :to=" '/notarizationDetails?id=' + item.orderSeqNo ">确认函详情
                        </router-link>
                    </i-col>
                </Row>
                <div class="commont-page"
                     style="position:absolute;bottom:10px;left:50%;transform:translate(-50%, -50%)">
                    <Page :page-size="pageSize" :current="pageNumber" @on-change="changepage" :total="total"
                          size="small" show-total show-elevator class="page-size-style"></Page>
                    <span class="page-total-span">/&nbsp;{{pages}}页</span>
                </div>
            </div>
            <div class="empty-box" v-if="records.length<=0&&flag">
                <img src="@/assets/empty.png" class="empty-img" alt='版权登记'/>
                <p>表单暂无数据哦～</p>
            </div>
        </div>
    </div>
</template>

<script>
    import Cookies from "js-cookie";
    import {_getNotarizationPage} from '@/api/notarization';


    export default {
        name: "myNotarization",
        data() {
            return {
                total: 0,
                pageSize: 8,
                pageNumber: 1,
                startDate: '',
                endDate: '',
                name: '',
                value2: [],
                records: [],
                flag: false,
                pages: 0,
                ifNotarizationSuccess: require('@/assets/notarization_active.png'),
                ifNotarizationFail: require('@/assets/notarization.png'),
            }
        },
        methods: {
            changeDate(starttime, endtime) {
                this.startDate = starttime ? starttime[0] : '';
                this.endDate = starttime ? starttime[1] : '';
                this.pageNumber = 1;
                this.getNotarizationPage();
            },
            addworkname() {
                this.pageNumber = 1;
                this.getNotarizationPage();
            },
            changepage(index) {
                this.pageNumber = index
                this.getNotarizationPage();
            },

            /****************************获取电子存证列表数据*************************/
            getNotarizationPage() {
                let _this = this;
                let userInfo = JSON.parse(Cookies.get("userInfo"));

                let params = {
                    sort: 'create_date',
                    order: 'desc',
                    pageNumber: _this.pageNumber,
                    pageSize: _this.pageSize,
                    orderSeqNo: '',
                    name: _this.name,
                    startDate: _this.startDate,
                    duration: _this.endDate,
                    registerId: userInfo && userInfo.id ? userInfo.id : '',

                }

                _getNotarizationPage(params).then(res => {
                    if (res.code == 200) {
                        _this.records = res.result.records
                        _this.total = Number(res.result.total)
                        _this.flag = true;
                        _this.pages = res.result.pages
                    }
                })


            }
        },
        mounted() {
            this.getNotarizationPage();
        }
    }
</script>

<style scoped>
    .jump_link {
        color: #FF8800;
    }

    .notarization_icon {
        display: inline-block;
        width: 20px;
        height: 20px;
    }
</style>